import { Box, Flex } from '@huspy/briks-web';
import { AnimatedLoader } from '@components/AnimatedLoader';

export const PendingComponent = () => (
  <Flex flex={ 1 } direction='row' align='center' justify='center' style={ { height: 'calc(90vh - 108px)' } }>
    <Box>
      <AnimatedLoader dark />
    </Box>
  </Flex>
);
